export default "__VITE_ASSET__xHldclXe__"